module.exports = __webpack_public_path__ + "img/blue-logo.6bcaa631.svg";